import { bool } from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";
import { color } from "theme";

import { useBackgroundColor, useMediaSettings } from "Signups/stateHooks";

import FnrSlides from "UI/FnrSlides";

import ImageHandler from "./ImageHandler";
import ImageVideoSectionSettingsError from "./ImageVideoSectionError";
import VideoInput from "./VideoInput";

const content = [
  {
    key: "video",
    value: VideoInput,
  },
  {
    key: "image",
    value: ImageHandler,
  },
];

export default function ImageVideoSection({ showingColorPicker }) {
  const { mediaSettings } = useMediaSettings();
  const { colorVariant } = useBackgroundColor();

  const isImage = mediaSettings?.type === "image" && mediaSettings?.imageUrl;
  const isVideo = mediaSettings?.type === "video";

  const [error, setError] = useState(null);

  return (
    <Wrapper $hasContent={isImage || isVideo} $colorVariant={colorVariant}>
      <FnrSlides
        activeKey={isVideo ? "video" : "image"}
        components={content}
        variant="subtle"
        fullWidth
        clip={false}
        setError={setError}
        showingColorPicker={showingColorPicker}
      />

      <ImageVideoSectionSettingsError hasError={Boolean(error)} error={error} />
    </Wrapper>
  );
}

ImageVideoSection.propTypes = {
  showingColorPicker: bool,
};

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  border-radius: 8px;
  max-width: 600px;
  max-height: 600px;
  margin: 0 auto;
  min-height: 157px;
  transition: background-color 150ms;

  ${color}
`;
